export default __webpack_public_path__ + "static/media/bg17.9d1cc9b8.jpg";